import React from 'react'
import { useSelector } from 'react-redux'
import { AppState } from 'web-common'
import {
    StyledSettingHeader,
    StyledSettingBody,
    StyledTheNightlySettingOption,
} from '../SettingScreen.styled'
import { SettingsScreenInnerProps } from '../SettingScreen'
import { IconChevronRightTN } from '../../../icons/IconChevronRightTN/IconChevronRightTN'
import { ScreenType } from '../../hooks/useScreen'

interface SettingOptionProps {
    label: string
    text: string
    onClick: () => void
    isActive?: boolean
}

interface SettingsMenuItem {
    label: string
    text: string
    screen: ScreenType
}

export const TheNightlySettingsScreen = ({
    activeIndex,
    onMenuItemClick,
}: SettingsScreenInnerProps) => {
    const authState = useSelector((state: AppState) => state.authentication)
    const { userName, userEmail } = authState
    // Auth0 defaults userName as email
    const hasName = userName !== userEmail

    return (
        <>
            <h2>Settings</h2>
            {hasName && <h3>{userName}</h3>}
            <StyledSettingHeader>
                <li>
                    <small>Email</small>
                    <p>{userEmail}</p>
                </li>
            </StyledSettingHeader>
            <StyledSettingBody>
                {getMenuItems().map((item, index) => (
                    <SettingOption
                        key={index}
                        label={item.label}
                        text={item.text}
                        isActive={index === activeIndex}
                        onClick={() => onMenuItemClick(index, item.screen)}
                    />
                ))}
            </StyledSettingBody>
        </>
    )
}

const getMenuItems = (): SettingsMenuItem[] => [
    {
        label: 'Account',
        text: 'Manage account',
        screen: 'manage-account',
    },
    // We want to hide this option below, for now,
    // but it is reserved for Phase 2 (Post Launch)
    // when finishing up the Newsletter feature
    /* {
            label: 'Email Preferences',
            text: 'Newsletters',
            screen: 'manage-account',
        }, */
]

const SettingOption: React.FC<SettingOptionProps> = ({
    label,
    text,
    isActive,
    onClick,
}) => {
    return (
        <StyledTheNightlySettingOption isActive={isActive} onClick={onClick}>
            <span>{label}</span>
            <button>
                <p>{text}</p>
                <IconChevronRightTN />
            </button>
        </StyledTheNightlySettingOption>
    )
}
